export default __webpack_public_path__ + "static/media/profit.b4eb6eb3.svg";